export default __webpack_public_path__ + "static/media/sparck-header-bottom-curved.07955a94.png";